export default __webpack_public_path__ + "static/media/triber-gallery-8.2ca01764.jpg";